var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConnections(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.36357 0H14.6363V7.27273H12.3896L18.1961 12.7273H21.909V20H14.6363V12.7273H16.8683L11.0619 7.27273H10.938L5.13157 12.7273H7.36355V20H0.0908203V12.7273H3.8038L9.61023 7.27273H7.36357V0Z",
    fill: "#0C8CE9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnections);
export default __webpack_public_path__ + "static/media/connections.3f3ba7e0f92ac6697b80dfd1c64640bd.svg";
export { ForwardRef as ReactComponent };